import { useEffect } from 'react';
import { useSensor, useSensors, PointerSensor, TouchSensor, KeyboardSensor } from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

export const useCompetitionEffects = ({
  isRunning,
  isPaused,
  currentSwimmerId,
  startTime,
  currentTime,
  setCurrentTime,
  swimmersData,
  setSwimmersData,
  totalTime,
  totalStartTime,
  setTotalTime,
  isCompetitionEnded,
  poolLength,
  raceDistance,
  results
}) => {
  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        delay: 750,
        tolerance: 5,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 750,
        tolerance: 5,
      },
    }),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    })
  );

  useEffect(() => {
    let interval;
    if (isRunning && !isPaused && currentSwimmerId) {
      const initialTime = currentTime || 0;
      const timeStart = Date.now() - initialTime;
      
      interval = setInterval(() => {
        const now = Date.now();
        const newTime = now - timeStart;
        
        setCurrentTime(newTime);
        localStorage.setItem('currentTime', newTime.toString());
        
        const updatedData = {
          ...swimmersData,
          [currentSwimmerId]: {
            ...swimmersData[currentSwimmerId],
            currentLapTime: newTime,
            poolLength: poolLength,
            raceDistance: raceDistance
          }
        };
        
        setSwimmersData(updatedData);
        localStorage.setItem('swimmersData', JSON.stringify(updatedData));
      }, 10);
    }
    return () => clearInterval(interval);
  }, [isRunning, isPaused, currentSwimmerId, startTime, currentTime, setCurrentTime, swimmersData, setSwimmersData, poolLength, raceDistance]);

  useEffect(() => {
    let interval;
    if ((totalTime > 0 || isRunning) && !isCompetitionEnded && totalStartTime) {
      const timeStart = totalStartTime;
      interval = setInterval(() => {
        const now = Date.now();
        const newTotalTime = now - timeStart;
        setTotalTime(newTotalTime);
        localStorage.setItem('totalTime', newTotalTime.toString());
      }, 10);
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isRunning, totalTime, totalStartTime, isCompetitionEnded, setTotalTime]);

  return { sensors };
};